import React from "react";
import PropTypes from "prop-types";
import { InputAdornment, TextField } from "@mui/material";

function TextInput({
  placeholder,
  name,
  value,
  onChange,
  InputStartIcon,
  type,
  InputEndIcon,
  id,
  fullWidth,
  multiline,
  rows,
  disabled,
  readonly,
  maxLength,
  inputError,
  helperText,
  variant,
  size,
  required,
  styleProps,
  InputProps,
  style,
  handleKeyDown,
}) {
  return (
    <TextField
      onKeyDown={handleKeyDown}
      style={style}
      sx={{ ...styleProps }}
      required={required}
      error={inputError}
      helperText={helperText}
      id={id}
      inputProps={{ maxLength: maxLength }}
      type={type}
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      InputProps={{
        ...InputProps,
        readOnly: readonly,
        startAdornment: InputStartIcon && (
          <InputAdornment position="start">{InputStartIcon}</InputAdornment>
        ),
        endAdornment: InputEndIcon && (
          <InputAdornment
            position="end"
            sx={{ cursor: "pointer", height: "100%" }}
          >
            {InputEndIcon}
          </InputAdornment>
        ),
      }}
    />
  );
}

TextInput.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  InputStartIcon: PropTypes.element,
  type: PropTypes.string,
  InputEndIcon: PropTypes.element,
  id: PropTypes.string,
  fullWidth: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  maxLength: PropTypes.number,
  inputError: PropTypes.bool,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  required: PropTypes.bool,
  styleProps: PropTypes.object,
};

TextInput.defaultProps = {
  type: "text",
  fullWidth: true,
  multiline: false,
  disabled: false,
  readonly: false,
  maxLength: 255,
  inputError: false,
  helperText: "",
  variant: "outlined",
  size: "small",
  required: true,
  styleProps: {},
};

export default TextInput;
